var map = {
	"./demos/basic/index.ts": 73218,
	"./demos/format/index.ts": 94964,
	"./demos/range/index.ts": 63677,
	"./demos/step/index.ts": 66509,
	"./demos/stepRange/index.ts": 58545
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54141;